<template>
    <vs-popup fullscreen :title="taskName" background-color-popup="#f8f8f8" :active.sync="popupActive">
        <single-task v-on:taskLoaded="taskName = $refs.taskPage.taskName" ref="taskPage"></single-task>
    </vs-popup>
</template>

<script>

    import SingleTask from "./Task/SingleTask";

    export default {
        components: {
            SingleTask,
        },
        data(){
            return {
                popupActive: true,
                taskName: 'Loading...',
            }
        },
        watch: {
            popupActive: function () {
                if (!this.popupActive){
                    this.$router.go(-1)
                }
            }
        },
    }
</script>
